import { useMemo } from "react";
import { HeldEmailSelectionModel } from "../../components/admin/system-emails/heldEmailSelection";
import { HeldEmailQueueTableModel } from "../../components/admin/system-emails/heldEmailQueueTableModel";

const ACTIONABLE_STATES = new Set(["pending", "blocked", "failed"]);

export function useHeldEmailTableSelection(model: HeldEmailQueueTableModel) {
  const actionableIds = useMemo(
    () =>
      model.canRelease
        ? model.emails
            .filter((email) => ACTIONABLE_STATES.has(email.state))
            .map((email) => email.id)
        : [],
    [model.canRelease, model.emails]
  );
  return useMemo<HeldEmailSelectionModel>(
    () => ({
      actionableIds,
      selectedIds: model.selectedIds,
      onChange: model.onSelectionChange,
    }),
    [actionableIds, model.onSelectionChange, model.selectedIds]
  );
}
